import { NotificationSettings } from 'domain/merchant';
import React from 'react';
import { Form } from 'react-bootstrap';

export interface MerchantNotificationSettingsProps {
    notificationSettings: NotificationSettings;
    onChange(settings: NotificationSettings): void;
}

const MerchantNotificationSettings: React.FC<MerchantNotificationSettingsProps> = props => {
    return <div className="mt-4">
    <div className="mb-3 header">
        <h4>Notifications</h4>
    </div>
    <div className="row settings-row">
        <div className="col-md-2">
            <label className="pr-1" htmlFor="notification-freight-fee">Freight</label>
        </div>
        <div className="col-md-2">
            <Form.Check
                type="switch"
                id="notification-freight-fee"
                label=""
                checked={props.notificationSettings.displayFreightFee}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    props.onChange({...props.notificationSettings, displayFreightFee: event.target.checked});
                }}
            />
        </div>
    </div>
    <div className="row settings-row">
        <div className="col-md-2">
            <label className="pr-1" htmlFor="notification-total-fees">Total Fees</label>
        </div>
        <div className="col-md-2">
            <Form.Check
                type="switch"
                id="notification-total-fees"
                label=""
                checked={props.notificationSettings.displayTotalFees}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    props.onChange({...props.notificationSettings, displayTotalFees: event.target.checked});
                }}
            />
        </div>
    </div>
    <div className="row settings-row">
        <div className="col-md-2">
            <label className="pr-1" htmlFor="notification-final-price">Final Price</label>
        </div>
        <div className="col-md-2">
            <Form.Check
                type="switch"
                id="notification-final-price"
                label=""
                checked={props.notificationSettings.displayFinalPrice}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    props.onChange({...props.notificationSettings, displayFinalPrice: event.target.checked});
                }}
            />
        </div>
    </div>
    <div className="row settings-row">
        <div className="col-md-2">
            <label className="pr-1" htmlFor="notification-use-symbol">Use Symbol</label>
        </div>
        <div className="col-md-2">
            <Form.Check
                type="switch"
                id="notification-use-symbol"
                label=""
                checked={props.notificationSettings.displaySymbol}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    var update = {...props.notificationSettings, displaySymbol: event.target.checked};
                    if (event.target.checked) {
                        update.displaySymbolMaturity = false;
                    }
                    props.onChange(update);
                }}
            />
        </div>
    </div>
    <div className="row settings-row">
        <div className="col-md-2">
            <label className="pr-1" htmlFor="notification--use-symbol-month">Use Symbol Month</label>
        </div>
        <div className="col-md-2">
            <Form.Check
                type="switch"
                id="notification-use-symbol-month"
                label=""
                checked={props.notificationSettings.displaySymbolMaturity}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    var update = {...props.notificationSettings, displaySymbolMaturity: event.target.checked};
                    if (event.target.checked) {
                        update.displaySymbol = false;
                    }
                    props.onChange(update);
                }}
            />
        </div>
    </div>
    <div className="row settings-row">
        <div className="col-md-2">
            <label className="pr-1" htmlFor="notification-delivery-period">Delivery Period</label>
        </div>
        <div className="col-md-2">
            <Form.Check
                type="switch"
                id="notification-delivery-period"
                label=""
                checked={props.notificationSettings.displayDeliveryPeriod}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    props.onChange({...props.notificationSettings, displayDeliveryPeriod: event.target.checked});
                }}
            />
        </div>
    </div>
    <div className="row settings-row">
        <div className="col-md-2">
            <label className="pr-1" htmlFor="notification-crop-year">Crop Year</label>
        </div>
        <div className="col-md-2">
            <Form.Check
                type="switch"
                id="notification-crop-year"
                label=""
                checked={props.notificationSettings.displayCropYear}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    props.onChange({...props.notificationSettings, displayCropYear: event.target.checked});
                }}
            />
        </div>
    </div>
</div>;
}

export default MerchantNotificationSettings;